__turbopack_context__.v({
  "Checkbox": "Input-module-scss-module__oG8IhW__Checkbox",
  "InputV2__root": "Input-module-scss-module__oG8IhW__InputV2__root",
  "Input__FieldFont": "Input-module-scss-module__oG8IhW__Input__FieldFont",
  "Input__Field_Dark": "Input-module-scss-module__oG8IhW__Input__Field_Dark",
  "SelectContainer": "Input-module-scss-module__oG8IhW__SelectContainer",
  "SelectContainerV2": "Input-module-scss-module__oG8IhW__SelectContainerV2",
  "btn": "Input-module-scss-module__oG8IhW__btn",
  "btnContent": "Input-module-scss-module__oG8IhW__btnContent",
  "btnSpinner": "Input-module-scss-module__oG8IhW__btnSpinner",
  "btnSpinnerHidden": "Input-module-scss-module__oG8IhW__btnSpinnerHidden",
  "error": "Input-module-scss-module__oG8IhW__error",
  "is-error": "Input-module-scss-module__oG8IhW__is-error",
  "is-readonly": "Input-module-scss-module__oG8IhW__is-readonly",
  "is-valid": "Input-module-scss-module__oG8IhW__is-valid",
  "selectDropdown": "Input-module-scss-module__oG8IhW__selectDropdown",
  "submitBtnSpin": "Input-module-scss-module__oG8IhW__submitBtnSpin",
});
